import { ImpurityExpansionElement, PowderComposition } from "../../../services/PowderFormService";
import { FileReference } from "../OiReport";
export enum FurnaceType{
  PRODUCTION = "Production furnace",
  LAB = "Lab furnace"
}

export class OiReportForm{
 author: string = "";
}

export class RawMaterialControl {
  author: string = "";
  orderId: string = "";
  title: string = "";
  isDraft: boolean = true;
  batchG: number = 0;
  weightOnMillKg: string = "0.25"
  grindingBodiesType: string = "PS181 sort 465";
  grindingBodiesComment: string = "";
  grindingBodies: number = 3;
  grindTimeHours: number = 10;
  grindTimeMinutes: number = 0;
//grindTime: string = "20h 30min";
  weightUnit: string = 'kg';
  alcohol: number = 0.2
  alcoholComment: string = "";
  isUsedForInserts: boolean = true;
  geometry: string = "";
  amount: string = "";
  pressPressure: string = "";
  sinteringCode: string = "";
  sinteringTemperature: string = "";
  furnaceType: FurnaceType = FurnaceType.PRODUCTION;
  comment: string = "";
  tags: string[] = [];
  taggedStaff: string[] = [];
  uploadedFiles: FileReference[] = [];
  amountToBalance: number = 0;
  targetPercents: TargetPercent[] | null = null;
  achieved_pct?: Record<string, number>;
  balanceElement: string | null = null;
  showImpurityExpansion: boolean = false;
  selectedElements: string[] = [];
  responseElements: string[] = [];
  lumpImpuritiesElement: string | null = null;
  elementRatios: ElementRatios[] = [];
  materials: RawMaterial[] = [];
  prz: Prz = {
    enabled: false,
    selected_lot: null,
    ratio_pct: null,
  };
  supplierMaterialCode: string = "";
  batchNumber: string = "";
  regNr: string = "";
}



export interface ElementRatios {
  [el: string]: string;
}

export interface Prz {
  enabled: boolean;
  selected_lot?: string | null;
  ratio_pct?: number | null;
}

export interface RawMaterial {
  role?: string;
  lot: string;
  raw_mtrl?: string;
  trim_element?: string;
  rvid: string;
  lumpedInto?: string;
  ratio?: string;
  pegRatio?: string;
  recycledRatio?: string;
  includedElementsMatrix?: string[];
  ratioPercent?: number | null;
  cPercent?: number | null;
  oPercent?: number | null;
  inStockGrams?: number;
  contributionPercent?: Record<string, number>;
  weightG?: number;
  comment?: string;
  powderComposition?: PowderComposition[] | null;
  impurityExpansion? : ImpurityExpansionElement[]
  nonSelectedElements?: NonSelectedElements;
  achievedPercent?: AchievedPercent[];
}


export interface NonSelectedElements {
  element: string;
  fraction_in_lot: number;
  contribution_g: number;
  contribution_to_batch_g: number;
}

export interface TargetPercent {
  symbol: string;
  value: number | null;
  displayValue?: string;
}

export interface ContributionPercent {
  [symbol: string]: number;
}

export interface AchievedPercent {
  [symbol: string]: number;
}

export class RawMaterialControlRepository {
  private rawMaterialControl: RawMaterialControl;

  constructor(initialData: RawMaterialControl) {
    this.rawMaterialControl = initialData;
  }

  get(): RawMaterialControl {
    return this.rawMaterialControl;
  }

  set(rawMaterialControl: RawMaterialControl) {
    this.rawMaterialControl = rawMaterialControl;
  }
}